import { render, staticRenderFns } from "./PasswordResetRequestSent.vue?vue&type=template&id=24524692&scoped=true"
import script from "./PasswordResetRequestSent.vue?vue&type=script&lang=js"
export * from "./PasswordResetRequestSent.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetRequestSent.vue?vue&type=style&index=0&id=24524692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24524692",
  null
  
)

export default component.exports